<template>
  <div class="classify" v-loading="loading">
    <div class="classify-block">
      <div class="classify-first">
        <div class="classify-first-addition" @click="additionBtn">
          <img class="addition-img" src="../../assets/common/common-add.png" />
          <div class="addition-text">添加</div>
        </div>
      </div>

      <div class="classify-second">
        <div class="classify-second-table">
          <el-table
            :data="tableData"
            border
            style="width: 100%; cursor: pointer"
            :header-cell-style="{
              color: '#333333',
              backgroundColor: '#FAFAFA',
            }"
          >
            <!-- 自定义暂无数据 -->
            <template slot="empty">
              <div class="empty-block">
                <img
                  class="empty-block-img"
                  src="../../assets/common/common-empty.png"
                />
                <div class="empty-block-text">暂无数据～</div>
              </div>
            </template>
            <el-table-column prop="name" label="一级分类名称">
            </el-table-column>
            <el-table-column label="一级类目图片">
              <template slot-scope="scope">
                <img class="table-compile1" :src="scope.row.image" />
              </template>
            </el-table-column>

            <el-table-column label="二级分类">
              <template slot-scope="scope">
                <div class="table-compile" @click="examineBtn(scope.row)">
                  查看
                </div>
              </template>
            </el-table-column>

            <el-table-column label="状态">
              <template slot-scope="scope">
                <div
                  class="table-status"
                  :style="{
                    color: scope.row.is_yc_switch == 0 ? '' : '#ED6D1F',
                  }"
                >
                  {{ scope.row.is_yc_switch == 0 ? '展示' : '隐藏' }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="table-operation">
                  <div
                    class="table-operation-left"
                    @click="compileBtn(scope.row)"
                  >
                    编辑
                  </div>
                  <div
                    class="table-operation-right"
                    @click="compileDetele(scope.row)"
                  >
                    删除
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="classify-second-Pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="prev, pager, next, sizes"
            :total="totalNum"
          >
          </el-pagination>
        </div>
      </div>

      <!--第一区域添加 -->
      <div class="addition">
        <el-dialog
          :visible.sync="additionDialogVisible"
          style="margin-top: 15vh"
          :show-close="false"
          :style="{
            '--height': transferHeight == false ? '1.09375rem' : '1.25rem',
          }"
          @close="addReset"
        >
          <span slot="footer" class="dialog-footer">
            <div class="addition-div">
              <div class="addition-div-top">
                <div class="block-top-title">添加</div>
                <img
                  class="block-top-close"
                  src="../../assets/common/close.png"
                  @click="addReset"
                />
              </div>
              <div class="addition-div-hint" v-if="transferHeight == true">
                <div class="addition-div-hint-title">
                  抱歉！名称不可超过10个字。
                </div>
              </div>

              <div class="addition-div-center">
                <div class="center-title">一级分类名称</div>
                <div class="center-input">
                  <el-input
                    placeholder="名称不可超过10个字"
                    v-model="additionTitle"
                    clearable
                  >
                  </el-input>
                </div>

                <div class="center-title top">一级分类排序</div>
                <div class="center-input">
                  <el-input
                    placeholder="分类排序"
                    v-model="compileSort"
                    clearable
                  >
                  </el-input>
                </div>
              </div>

              <div class="addition-div-button">
                <div class="button-confirm" @click="addConfirm">确 定</div>
              </div>
            </div>
          </span>
        </el-dialog>
      </div>

      <!--第二区域操作编辑-->
      <div class="compile">
        <el-dialog
          :visible.sync="compileDialogVisible"
          style="margin-top: 15vh"
          :show-close="false"
          @close="compileReset"
          :style="{
            '--height': transferHeight == false ? '1.35rem' : '1.50625rem',
          }"
        >
          <span slot="footer" class="dialog-footer">
            <div class="compile-div">
              <div class="compile-div-top">
                <div class="block-top-title">编辑</div>
                <img
                  class="block-top-close"
                  src="../../assets/common/close.png"
                  @click="compileReset"
                />
              </div>

              <div class="compile-div-hint" v-if="transferHeight == true">
                <div class="compile-div-hint-title">
                  抱歉！名称不可超过10个字。
                </div>
              </div>

              <div class="compile-div-center">
                <div class="center-title">一级分类名称</div>
                <div class="center-input">
                  <el-input
                    placeholder="名称不可超过10个字"
                    v-model="compileTitle"
                    clearable
                  >
                  </el-input>
                </div>

                <div class="center-title top">一级分类排序</div>
                <div class="center-input">
                  <el-input
                    placeholder="分类排序"
                    v-model="compileSort"
                    clearable
                  >
                  </el-input>
                </div>

                <div class="center-display">
                  <div class="display-left">
                    <div class="center-block-left-title">一级类目图片</div>
                    <div class="center-block-left-view">
                      <el-upload
                        class="upload-img"
                        ref="upload1"
                        action="https://laravel-api-manager.xmw1688.com/common/upload"
                        list-type="picture-card"
                        :on-success="handleSuccess"
                        :limit="1"
                        :show-file-list="false"
                      >
                        <img
                          v-if="commodityMasterImg != ''"
                          :src="commodityMasterImg"
                          class="avatar"
                        />
                        <img
                          v-else
                          src="../../assets/common/common-uploadings.png"
                          class="avatar"
                        />

                        <img
                          class="detele"
                          v-if="commodityMasterImg != ''"
                          src="../../assets/common/common-detele.png"
                          alt=""
                          @click.stop="masterDetele"
                        />
                      </el-upload>
                    </div>
                  </div>

                  <div class="display-right">
                    <div class="center-status">状态</div>
                    <div class="center-status-display">
                      <div class="center-status-display-left">
                        <el-radio v-model="radio" label="0" size="16"
                          >展示</el-radio
                        >
                      </div>
                      <div class="center-status-display-right">
                        <el-radio v-model="radio" label="1" size="16"
                          >隐藏</el-radio
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="compile-div-button">
                <div class="button-confirm" @click="compileConfirm">确 定</div>
              </div>
            </div>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '../../utils/bus'

import {
  getcommodityClassify,
  postcommodityClassifyAdd,
  deletefncommodityClassifyDetele,
} from '../../api/commodity'

export default {
  data() {
    return {
      // 表格数据
      tableData: [],
      // 表格总条数
      totalNum: 0,
      // 添加弹出框开启关闭
      additionDialogVisible: false,
      // 一级分类名称
      additionTitle: '',
      // 表格区域 操作 编辑弹出
      compileDialogVisible: false,
      // 编辑弹出框中 一级分类名称
      compileTitle: '',
      compileSort: '',
      // 编辑弹出框中 单选这个状态是否隐藏
      radio: '0',
      // 编辑弹出框中  对应id
      compileId: 0,
      // 监听用户刷新
      loading: false,
      // 页面
      page: 1,
      // 条数
      limit: 10,
      // 判断添加弹出框是否添加错误
      transferHeight: false,
      // 控制当前页面功能性按钮开关
      commodityFunShow: false,
      // 上传图片
      commodityMasterImg: '',
    }
  },
  created() {
    this.loading = true
    // 获取商品一级分类接口请求
    this.getcommodity()

    setTimeout(() => {
      this.commodityFunShow = this.$store.state.pageFunctionShow
    }, 1000)
  },
  methods: {
    // 获取商品一级分类接口数据
    getcommodity() {
      let params = {
        name: '',
        pageSize: this.limit,
        pageNo: this.page,
      }

      getcommodityClassify(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取表格数组
          this.tableData = res.resultData.goodsSpecOneList
          // 表格总条数
          this.totalNum = res.resultData.totalNum

          this.loading = false
        }
      })
    },
    // 点击添加开启弹出框
    additionBtn() {
      if (this.commodityFunShow == false) {
        return
      }

      this.additionTitle = ''
      this.radio = ''
      this.compileSort = ''
      this.compileId = ''
      this.commodityMasterImg = ''
      this.transferHeight = false
      this.additionDialogVisible = true
    },
    // 添加弹出框点击  确认
    addConfirm() {
      console.log('点击', this.additionTitle.length)

      if (this.additionTitle.length <= 10) {
        let params = {
          id: '',
          name: this.additionTitle,
          weigh: this.compileSort,
          is_yc_switch: '',
        }

        postcommodityClassifyAdd(params).then((res) => {
          if (res.resultStatus == true) {
            this.$message({
              message: '新增成功！',
              type: 'success',
              duration: 2000,
            })

            this.additionDialogVisible = false
            this.getcommodity()
          }
        })
      } else {
        this.transferHeight = true
      }
    },

    // 添加弹出框 重置
    addReset() {
      this.compileTitle = ''
      this.radio = ''
      this.compileSort = ''
      this.compileId = ''
      this.commodityMasterImg = ''
      this.additionDialogVisible = false
    },

    // 表格二级分类查看跳转链接
    examineBtn(item) {
      if (this.commodityFunShow == false) {
        return
      }

      Bus.$emit('log', 'secondClassify', item)
    },
    // 表格  操作  编辑
    compileBtn(item) {
      if (this.commodityFunShow == false) {
        return
      }

      this.compileTitle = item.name
      this.radio = item.is_yc_switch == null ? '1' : item.is_yc_switch + ''
      this.compileSort = item.weigh
      this.commodityMasterImg = item.image
      this.compileId = item.id
      this.transferHeight = false
      this.compileDialogVisible = true
    },

    // 表格  操作  删除
    compileDetele(item) {
      if (this.commodityFunShow == false) {
        return
      }

      let params = item.id

      deletefncommodityClassifyDetele(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '删除成功 !',
            type: 'success',
            duration: 2000,
          })
          this.loading = true
          this.getcommodity()
        } else {
          //   this.$message({
          //     message: '抱歉！该类目已经关联已创建的商品，不可进行删除！',
          //     type: 'error',
          //     duration: 2000,
          //   })
        }
      })
    },

    // 编辑弹出框 重置
    compileReset() {
      this.compileDialogVisible = false
    },
    // 编辑弹出框 确定
    compileConfirm() {
      if (this.compileTitle.length <= 10) {
        let params = {
          id: this.compileId,
          name: this.compileTitle,
          image: this.commodityMasterImg,
          weigh: this.compileSort,
          is_yc_switch: this.radio, // 是否是隐藏或者展示
        }

        postcommodityClassifyAdd(params).then((res) => {
          if (res.resultStatus == true) {
            this.$message({
              message: '修改成功！',
              type: 'success',
              duration: 2000,
            })
            this.loading = true

            this.compileDialogVisible = false

            this.getcommodity()
          }
        })
      } else {
        this.transferHeight = true
      }
    },
    // 上传成功
    handleSuccess(file, fileList) {
      this.$refs.upload1.clearFiles()
      this.commodityMasterImg = file.resultData
    },
    masterDetele() {
      this.commodityMasterImg = ''
    },
    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      this.getcommodity()
      console.log(`每页 ${val} 条`)
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      this.getcommodity()
      console.log(`当前页: ${val}`)
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.classify {
  width: 100%;
  min-height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #edeff7;
  border-radius: 10px;
  position: relative;

  .classify-block {
    .classify-first {
      height: 80px;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 24px;
      box-sizing: border-box;

      .classify-first-addition {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 82px;
        height: 36px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        cursor: pointer;

        .addition-img {
          width: 13px;
          height: 13px;
          margin-right: 8px;
        }

        .addition-text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }

    .classify-second {
      .classify-second-table {
        padding: 0 24px 0;
        box-sizing: border-box;

        /deep/ .el-table thead {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          background: #d8d8d8;
        }

        /deep/ .el-table tr {
          height: 46px;
        }

        /deep/ .el-table__empty-text {
          line-height: 0;
        }

        .empty-block {
          margin-top: 62px;
          padding-bottom: 40px;

          .empty-block-img {
            width: 130px;
            height: 130px;
            margin: 0 auto;
          }

          .empty-block-text {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            margin-top: 10px;
            height: 17px;
            line-height: 17px;
          }
        }

        .table-compile1 {
        //   width: 120px;
          height: 90px;
        }

        .table-compile {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
        }

        .table-operation {
          display: flex;

          .table-operation-left,
          .table-operation-right {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2aa4ff;
            text-decoration: underline;
          }

          .table-operation-right {
            margin-left: 24px;
          }
        }

        .table-status {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
        }
      }

      .classify-second-Pagination {
        height: 88px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        /deep/ .el-pagination .btn-prev {
          padding: 0;
          width: 32px;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #d9d9d9;
          margin-right: 8px;
        }

        /deep/ .el-pagination .btn-next {
          padding: 0;
          width: 32px;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #d9d9d9;
        }

        /deep/ .el-pager li {
          padding: 0;
          width: 32px;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #d9d9d9;
          line-height: 32px;
          margin-right: 8px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
        }

        /deep/ .el-pager li.active {
          background: #000000;
          color: #ffffff;
        }

        /deep/ .el-input--mini .el-input__inner {
          height: 32px;
        }

        /deep/ .el-input__inner {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }

    // 添加弹出框
    .addition {
      /deep/ .el-dialog {
        width: 444px;
        height: var(--height) !important;
      }

      /deep/ .el-dialog__footer {
        padding: 0;
        text-align: left;
      }

      .addition-div {
        background: #ffffff;
        box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
          0px 9px 28px 0px rgba(0, 0, 0, 0.05),
          0px 6px 16px -8px rgba(0, 0, 0, 0.08);
        border-radius: 10px;

        .addition-div-top {
          display: flex;
          height: 56px;
          align-items: center;
          justify-content: space-between;
          padding: 0 24px;
          box-sizing: border-box;
          border-bottom: 1px solid #e9edf4;

          .block-top-title {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #222222;
          }

          .block-top-close {
            width: 10px;
            height: 10px;
            cursor: pointer;
          }
        }

        .addition-div-hint {
          height: 30px;
          background: rgba(249, 182, 60, 0.1);
          line-height: 30px;
          padding: 0 24px;
          box-sizing: border-box;

          .addition-div-hint-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ed6d1f;
          }
        }

        .addition-div-center {
          padding: 0 24px;
          box-sizing: border-box;
          margin-top: 20px;

          .center-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }

          .center-input {
            width: 100%;
            margin-top: 4px;
            margin-bottom: 16px;

            /deep/ .el-input {
              height: 32px;
            }

            /deep/ .el-input__inner {
              padding: 0 10px;
              box-sizing: border-box;
              height: 32px;
              background-color: rgba(255, 255, 255, 0);
            }
          }
        }

        .addition-div-button {
          width: 100%;
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 0 16px;
          box-sizing: border-box;
          border-top: 1px solid #d9d9d9;
          margin-top: 9px;

          .button-reset,
          .button-confirm {
            width: 65px;
            height: 32px;
            background: #ffffff;
            border-radius: 10px;
            border: 1px solid #e9edf4;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
          }

          .button-confirm {
            background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
            color: #ffffff;
            margin-left: 8px;
          }
        }
      }
    }

    // 编辑
    .compile {
      /deep/ .el-dialog {
        width: 444px;
        height: var(--height) !important;
      }

      /deep/ .el-dialog__footer {
        padding: 0;
        text-align: left;
      }

      .compile-div {
        background: #ffffff;
        box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
          0px 9px 28px 0px rgba(0, 0, 0, 0.05),
          0px 6px 16px -8px rgba(0, 0, 0, 0.08);
        border-radius: 10px;

        .compile-div-top {
          display: flex;
          height: 56px;
          align-items: center;
          justify-content: space-between;
          padding: 0 24px;
          box-sizing: border-box;
          border-bottom: 1px solid #e9edf4;

          .block-top-title {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #222222;
          }

          .block-top-close {
            width: 10px;
            height: 10px;
            cursor: pointer;
          }
        }

        .compile-div-hint {
          height: 30px;
          background: rgba(249, 182, 60, 0.1);
          line-height: 30px;
          padding: 0 24px;
          box-sizing: border-box;

          .compile-div-hint-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ed6d1f;
          }
        }

        .compile-div-center {
          padding: 0 24px;
          box-sizing: border-box;
          margin-top: 20px;

          .center-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }

          .center-input {
            width: 100%;
            margin-top: 4px;
            margin-bottom: 16px;

            /deep/ .el-input {
              height: 32px;
            }

            /deep/ .el-input__inner {
              padding: 0 10px;
              box-sizing: border-box;
              height: 32px;
              background-color: rgba(255, 255, 255, 0);
            }
          }

          .center-display {
            display: flex;
            justify-content: space-between;

            .display-left {
              .center-block-left-title {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .center-block-left-view {
                width: 100px;
                height: 100px;
                margin-top: 8px;
                cursor: pointer;
                position: relative;

                .upload-img {
                  width: 100px;
                  height: 100px;
                  position: relative;

                  /deep/ .el-upload--picture-card {
                    width: 100px;
                    height: 100px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid rgba(255, 255, 255, 0);
                  }

                  /deep/ .el-upload--picture-card:hover {
                    border-color: rgba(255, 255, 255, 0);
                  }

                  /deep/ .el-upload-list--picture-card .el-upload-list__item {
                    width: 100px;
                    height: 100px;
                    margin: 0;
                  }

                  .avatar {
                    width: 100px;
                    height: 100px;
                  }

                  .detele {
                    position: absolute;
                    top: -10px;
                    right: -10px;
                    width: 20px;
                    height: 20px;
                  }
                }
              }
            }

            .display-right {
              .center-status {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .center-status-display {
                display: flex;
                margin-top: 8px;

                .center-status-display-left {
                }

                .center-status-display-right {
                  margin-left: 52px;
                }
              }
            }
          }
        }

        .compile-div-button {
          width: 100%;
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 0 16px;
          box-sizing: border-box;
          border-top: 1px solid #d9d9d9;
          margin-top: 22px;

          .button-reset,
          .button-confirm {
            width: 65px;
            height: 32px;
            background: #ffffff;
            border-radius: 10px;
            border: 1px solid #e9edf4;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #555555;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
          }

          .button-confirm {
            background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
            color: #ffffff;
            margin-left: 8px;
          }
        }
      }
    }
  }
}
</style>
